import styled from 'styled-components';

import { Body } from '@cognite/cogs-core-v11/tokens/typography/typography.tsx';
import { Flex } from '@cognite/cogs-core-v11/components/flex/flex.tsx';

export const MigrationRequiredMessageContainer = styled(Flex)`
  padding: 12px;
  width: 1000px;
`;

export const Message = styled(Body)`
  padding: 6px;
`;
